import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { route as routePropType } from 'common/propTypes';
import { useOnMountDataRequest } from 'common/hooks';
import { managePermission } from 'payments/propTypes';
import { ordersRoute } from 'app/containers/routes';
import { selectors as authSelectors } from 'auth';

import OverviewPage from './Overview';
import HistoryPage from './History';
import { actions } from '../index';

const Routes = ({ match, rewardsPermission, isFetching }) => {
  useOnMountDataRequest(actions.rewardsRequest);

  if (isFetching) return null;

  const canManageRewards = rewardsPermission === managePermission;

  if (!canManageRewards) {
    return <Redirect to={ordersRoute} />;
  }

  const overviewRoute = `${match.path}/overview`;
  const historyRoute = `${match.path}/history`;

  return (
    <Switch>
      <Route
        exact
        path={match.path}
        component={() => <Redirect to={overviewRoute} />}
      />
      <Route exact path={overviewRoute} component={OverviewPage} />
      <Route exact path={historyRoute} component={HistoryPage} />
    </Switch>
  );
};

Routes.propTypes = {
  ...routePropType,
  rewardsPermission: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const ConnectedRoutes = connect((state) => {
  const { loading: isFetching, rewards: rewardsPermission } =
    authSelectors.getPermissions(state);

  return {
    rewardsPermission,
    isFetching: !!isFetching,
  };
})(Routes);

export default ConnectedRoutes;
